import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { QueryFetchFunction, QueryTransformer } from 'common/helpers/common';
import { ApiError, ExtendedApiResult } from 'common/repositories/common.model';

import { getPurchaseListInput, PurchaseListModel } from './model';

export function useGetPurchase(
  input?: getPurchaseListInput,
  options?: UseQueryOptions<ExtendedApiResult<PurchaseListModel[]>, ApiError>,
): UseQueryResult<ExtendedApiResult<PurchaseListModel[]>, ApiError> {
  return QueryTransformer(
    useQuery(
      ['getPurchases', input?.params],
      () =>
        QueryFetchFunction({
          url: `tours/${input?.id}/get-purchases`,
          params: input?.params,
        }),
      options,
    ),
    PurchaseListModel,
  );
}
